import styled from '@emotion/styled';
import { tokens, Link } from '@hotjar/hotsauce';
import { useCurrentSite } from '@hotjar/site';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { EmptyState } from '@hotjar/webapp/components/EmptyState';
import PendingInstallation from '@hotjar/shared-assets/images/brand-get-started-new.png';
import { useTranslation } from 'react-i18next';
import { skipInstallation } from '@hotjar/webapp/features/Surveys/domain/userSettings';
import { useCurrentUser } from '@hotjar/user';
import { navigateToInstaller } from '@hotjar/webapp/domains/activation/routing';

export const PendingInstallationEmptyState = (): JSX.Element => {
  const { t } = useTranslation();
  const { data: currentSite } = useCurrentSite();
  const { click: trackClick } = useTrack();
  const onInstallClick = () => {
    if (currentSite?.id) {
      navigateToInstaller(currentSite);
      trackClick('Install Tracking Code', 'Pending Installation Empty State', {});
    }
  };
  return (
    <EmptyState
      title={t('activation:empty-states.pending-installation.title')}
      subtitle={t('activation:empty-states.pending-installation.subtitle')}
      img={PendingInstallation}
      buttonText={t('activation:empty-states.pending-installation.install-tracking-code')}
      onButtonClick={onInstallClick}
    />
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  margin-top: ${tokens.spacer.x3};
`;

interface SurveysPendingInstallationEmptyStateProps {
  onSkip: () => void;
}

export const SurveysPendingInstallationEmptyState = ({
  onSkip,
}: SurveysPendingInstallationEmptyStateProps): JSX.Element => {
  const { t } = useTranslation();
  const { data: currentSite } = useCurrentSite();
  const { data: user } = useCurrentUser();
  const { click: trackClick } = useTrack();
  const onSkipClick = () => {
    trackClick('Skip Installation', 'Surveys List', {});
    if (user && currentSite?.id) skipInstallation(user.id, currentSite.id);
    onSkip();
  };

  return (
    <Wrapper>
      <PendingInstallationEmptyState />
      <StyledLink as="button" kind="inline" onClick={onSkipClick}>
        {t('activation:empty-states.pending-installation.use-surveys-without-installing')}
      </StyledLink>
    </Wrapper>
  );
};
